<div *ngIf="showFeeNotification && isUserFlow" class="alert alert-info " style="position: relative;">
    <div *ngIf="organization.rates.merchantRate > 0 && paymentMethod && (paymentMethod.value === 'new-credit-card' || paymentMethod.value.cardBrand) && !organization.profile.absorbsCcFees">
        <em>
            A {{organization.rates.merchantRate | number:'.0-2'}}
            %<span *ngIf="organization.rates.merchantMinimum"> +{{organization.rates.merchantMinimum * 100}}&cent;</span> processing fee will be charged for this credit card
            payment.
            <span *ngIf="organization.rates.checkRateFlat === 0">
                To avoid processing fees, please change the method of payment.
            </span>
        </em>
    </div>
    <div *ngIf="organization.rates.checkRateFlat > 0 && paymentMethod && (paymentMethod.value === 'new-bank-account' || paymentMethod.value.routingNumber) && !organization.profile.absorbsAchFees">
        <em>
            A {{organization.rates.checkRateFlat * 100 | legfiCurrency:'USD':'symbol':'.2'}} processing fee will be charged for this bank account
            payment.
        </em>
    </div>
</div>

<div class="form-group">
    <div class="form-inline">

        <label class="mr-2">Payment Type: *</label>

        <select (ngModelChange)="changeSelectedPaymentMethod($event)"
                *ngIf="!isLoadingPaymentMethods"
                [class.error]="isPaymentMethodNotSelected"
                [disabled]="disabled"
                [ngModel]="paymentMethod" class="form-control mr-2">

            <option [value]="null" disabled selected>-- Select One --</option>

            <!--suppress HtmlUnknownAttribute -->
            <ng-template *ngIf="paymentMethods && paymentMethods.length" [ngForOf]="paymentMethods" let-pm
                         ngFor>
                <option *ngIf="pm.value === 'new-bank-account'" [ngValue]="pm">New Checking Account</option>
                <option *ngIf="pm.value === 'new-credit-card'" [ngValue]="pm">New Credit Card</option>
                <option *ngIf="pm.type === 'CreditCard' && pm.value.id" [ngValue]="pm">
                    {{pm.value.cardBrand}} - ************{{pm.value.last4}}
                </option>
                <option *ngIf="pm.type === 'CardToken' && pm.value.id" [ngValue]="pm">
                    {{pm.value.brand}} - ************{{pm.value.last4}} (no save)
                </option>
                <option *ngIf="pm.type === 'PaymentBankAccount' && pm.value.id"
                        [innerHTML]=""
                        [ngValue]="pm">
                    {{pm.value.friendlyName}}<span *ngIf="!pm.value.verifiedMicrodeposits"> (unverified)</span>
                </option>
            </ng-template>
        </select>
    </div>
</div>

<!-- this row shows up if bank account -->
<div *ngIf="paymentMethod && paymentMethod.type === 'PaymentBankAccount' && paymentMethod.value && paymentMethod.value !== 'new-bank-account'"
     class="row">

    <div class="col-md-6 col-sm-12">
        <label>Bank Details</label>
        <div>
            <span class="detail-label"> Name: </span>
            <span [innerHTML]="paymentMethod.value.friendlyName"></span>

        </div>
    </div>
    <div class="col-md-6 col-sm-12">
        <label>Account</label>
        <div>
            <span class="detail-label"> Routing:</span>
            xxxxx{{paymentMethod.value.routingNumber ? paymentMethod.value.routingNumber.substring(paymentMethod.value.routingNumber.length - 4) : 'xxxx'}}
        </div>
        <div>
            <span class="detail-label"> Account:</span>
            xxxxx{{paymentMethod.value.last4}}
        </div>
    </div>
</div>


<!-- this shows up if creditcard-->
<div *ngIf="paymentMethod && paymentMethod.type.indexOf('CreditCard') !== -1 && paymentMethod.value.cardBrand"
     class="row">
    <div class="col-md-6 col-sm-12">
        <label>
            Card Details
        </label>

        <div>
            <span class="detail-label">
                Type:
            </span>
            <span class="detail-value">
                <i [class.fa-cc-amex]="paymentMethod.value.cardBrand === 'American Express'"
                   [class.fa-cc-dinersclub]="paymentMethod.value.cardBrand === 'Diners Club'"
                   [class.fa-cc-discover]="paymentMethod.value.cardBrand === 'Discover'"
                   [class.fa-cc-jcb]="paymentMethod.value.cardBrand === 'JCB'"

                   [class.fa-cc-mastercard]="paymentMethod.value.cardBrand === 'MasterCard'"
                   [class.fa-cc-visa]="paymentMethod.value.cardBrand === 'Visa'"
                   [class.fa-credit-card]="!paymentMethod.value.cardBrand || paymentMethod.value.cardBrand === 'Unknown'"
                   [class.text-muted]="!paymentMethod || !paymentMethod.value || !paymentMethod.value.cardBrand || paymentMethod.value.cardBrand === 'Unknown'"
                   [class.text-primary]="paymentMethod.value.cardBrand && paymentMethod.value.cardBrand !== 'Unknown'"
                   class="fa "
                   style="font-size: 21px;"
                ></i>
            </span>
        </div>
        <div>
            <span class="detail-label">
                Card Number:
            </span>
            <span class="detail-value">
                **** **** **** {{paymentMethod.value.last4}}
            </span>
        </div>
        <div>
            <span class="detail-label">
                Expiry:
            </span>
            <span class="detail-value">
                {{paymentMethod.value.expMonth}}/{{paymentMethod.value.expYear}}
            </span>
        </div>
        <div>
            <span class="detail-label">
                Name on Card:
            </span>
            <span class="detail-value">
                {{paymentMethod.value.name}}
            </span>
        </div>
    </div>

    <div class="col-md-6 col-sm-12">
        <label>Billing Address</label>
        <div>
            {{paymentMethod.value.address1}}
            <br *ngIf="paymentMethod.value.address2"/>
            {{paymentMethod.value.address2}}
        </div>

        <div>
            {{paymentMethod.value.city}}, {{paymentMethod.value.state}} {{paymentMethod.value.zip}}
            {{paymentMethod.value.country}}
        </div>
    </div>
</div>

<lf-credit-card-collector #creditCardCollector
                          (saved)="creditCardAdded($event);"
                          *ngIf="!orgCharges"
                          [organization]="!!orgCharges && organization ? organization : null"
                          [paymentMethod]="paymentMethod"
                          [doStackColumns]="doStackColumns"
                          [savable]="ccSavable"></lf-credit-card-collector>

<lf-bank-account-manager #bankAccountManagerComponent
                         (paymentBankAccountSaved)="resetAccountManager($event);"
                         (unifiedBankAccountSaved)="resetAccountManager($event?.paymentBankAccount);"
                         [context]="isUserFlow ? 'user' : 'organization'"></lf-bank-account-manager>
